import {Component, OnInit, HostListener, ElementRef} from '@angular/core';
import {InAppNotificationsService} from './notifications.service';
import {UserDetailsService} from '../shared/user.details.service';
import {ToasterService} from 'angular2-toaster';
import {Subscription} from 'rxjs';
import {TimerObservable} from 'rxjs/observable/TimerObservable';

@Component({
    selector: 'notifications',
    templateUrl: 'notifications.component.html',
    styleUrls: ['notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
    private notificationsCollapsed = false;
    private notifications: any[] = [];
    private hasMore = false;
    private hasUnread = false;
    private currentPage = 0;
    private user;

    // Subscription to update notifications
    private notificationsSubscription: Subscription;

    constructor(private notificationsService: InAppNotificationsService,
                private userDetails: UserDetailsService,
                private toasterService: ToasterService,
                private elementRef: ElementRef) {
        this.user = localStorage.getItem('userName');
    }

    ngOnInit() {
        this.notifications = [];

        // Disabling notifications as its making too many calls and no one is really using it

        //
        //
        // this.getNotifications();
        // // Create a 2 minute timer to update notifications
        // const notificationsTimer = TimerObservable.create(120000, 120000);
        // this.notificationsSubscription = notificationsTimer.subscribe(() => {
        //     this.notificationsService.getNotifications(this.user, 0)
        //         .then((res) => {
        //             const idsPresent = this.notifications.map((item) => item.id);
        //             for (const notification of res.notifications.reverse()) {
        //                 if (!idsPresent.includes(notification.id)) {
        //                     this.notifications.unshift(notification);
        //                 }
        //             }
        //         })
        //         .catch((err) => {
        //             console.error('Failed to get most recent requests: ' + err.toString());
        //         });
        // });
    }

    handleCollapse(notification) {
        // Update the notification to be read
        if (!notification.notification_read) {
            this.notificationsService.postRead(notification.id)
                .catch((err) => {
                    console.error('Failed to set notification to read: ' + err.toString());
                });
        }
        notification.collapse = !notification.collapse;
        notification.notification_read = true;
        if (this.notifications.every((item) => item.notification_read)) {
            this.hasUnread = false;
        }
    }

    handleLoadMore() {
        // Need to see page info for notifications if there are more pages
        // If there are, show a load more button which loads another 10 older notifications
        if (this.hasMore) {
            this.currentPage += 1;
            this.getNotifications();
        }
    }

    getNotifications() {
        this.notificationsService.getNotifications(this.user, this.currentPage)
            .then((res) => {
                this.notifications = this.notifications.concat(
                    res.notifications.map((item) => {
                        item.created_on = new Date(item.created_on).toLocaleDateString('ja');
                        return item;
                    })
                );
                this.hasMore = res.hasMore;
                if (this.notifications.find((item) => !item.notification_read)) {
                    this.hasUnread = true;
                }
            })
            .catch((err) => {
                console.error('Failed to load notifications: ' + err.toString());
                this.toasterService.pop('error', 'Failed to load notifications');
            });
    }

    private insideClick = false;

    @HostListener('click')
    clickInside() {
        this.insideClick = true;
    }

    @HostListener('document:click', ['$event'])
    documentClick(event: any) {
        if (!this.insideClick) {
            // It wasn't an inside click, handle outside click.
            this.notificationsCollapsed = false;
        }
        this.insideClick = false;
    }
}


// WEBPACK FOOTER //
// ./src/app/notifications/notifications.component.ts